import { BomItemDetailsDrawerProps } from 'features/BomItemDetailsDrawer/BomItemDetailsDrawer'
import { useDialogManager } from 'features/DialogManager/DialogManager'
import { debounce } from 'lodash'
import { BoMItemType } from 'model/Project/BoMItemRow'
import { useCallback } from 'react'
import { useAppSelector } from 'store/configureStore'
import { useAppDispatch } from 'store/configureStore'
import { ToggleNewItemsModal } from 'store/Application/appActions'
import { newProjectActions } from '../store/newProjectReducer'
import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'

const debounced = debounce(
  (
    isBuyerView,
    dispatch,
    openDialog,
    bomItemId,
    bomItemType,
    includeBomItemInSearch,
    detailTabIndex
  ) => {
    if (isBuyerView) {
      return null
    }

    dispatch(ToggleNewItemsModal(false))
    setTimeout(() => {
      openDialog('BomItemDetailsDrawer', {
        bomItemId: bomItemId,
        bomItemType: bomItemType,
        detailTabIndex: detailTabIndex,
      } as BomItemDetailsDrawerProps)
    })

    if (includeBomItemInSearch) {
      dispatch(newProjectActions.setBomItemInSearch(bomItemId))
      dispatch(
        newProjectActions.setOpen({
          bomItemId: bomItemId,
          isOpen: true,
        })
      )
    }
  }
)

export const useBomItemDetails = () => {
  const { openDialog } = useDialogManager()
  const dispatch = useAppDispatch()

  const isBuyerView = useAppSelector(
    projectSelectors.ProjectInBuyerViewSelector
  )

  const handleOpenBomItemDetails = useCallback(
    (
      bomItemId: string,
      bomItemType: BoMItemType,
      includeBomItemInSearch: boolean,
      detailTabIndex?: number
    ) =>
      debounced(
        isBuyerView,
        dispatch,
        openDialog,
        bomItemId,
        bomItemType,
        includeBomItemInSearch,
        detailTabIndex
      ),
    [dispatch, isBuyerView, openDialog]
  )

  return {
    handleOpenBomItemDetails,
    isBuyerView,
  }
}
